import useSWR, {SWRConfiguration} from "swr";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {uuid} from "../../../types/veboxModels";
import {AvailableRegister} from "../models/AvailableRegister";
import {DeviceSlaveCurrentSettings} from "../models/DeviceSlaveSetting";
import {UpdatingSettings} from "../models/UpdatingSetting";
import {isRWSupportedCheckResponse} from "../models/isRWSupportedCheck";
import {CurrentSettingsUpdateResult} from "../models/CurrentSettingsUpdateResult";
import {ThermostatDetails} from "../models/ThermostatDetails";
import {getBaseUrl} from "../controllers/ReadAndWriteController";


export function useDeviceSlaveAvailableRegisters(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid)}availableRegisters`,
        params: {}
    }
    return useSWR<AvailableRegister[], Error>(configuration, RestDataLoader.fetchData);
}

export function useDeviceSlaveSettings(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid)}currentSettings`,
        params: {}
    }
    return useSWR<DeviceSlaveCurrentSettings, Error>(configuration, RestDataLoader.fetchData);
}


export function useUpdatingProgressInfo(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid)}updatingProgressInfo`,
        params: {}
    }
    return useSWR<UpdatingSettings, Error>(configuration, RestDataLoader.fetchData);
}

export function useIsRWSupportedCheck(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid)}isRWSupportedCheck`,
        params: {}
    }
    return useSWR<isRWSupportedCheckResponse, Error>(configuration, RestDataLoader.fetchData);
}


export function useCurrentSettingsUpdateResult(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid)}currentSettingsUpdateResult`,
        params: {}
    }
    return useSWR<CurrentSettingsUpdateResult, Error>(configuration, RestDataLoader.fetchData);
}

export function useSettingsUpdatesResults(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid)}settingsUpdatesResults`,
        params: {}
    }
    return useSWR<CurrentSettingsUpdateResult[], Error>(configuration, RestDataLoader.fetchData);
}

export function useDeviceSlaveDetails(deviceGuid: uuid) {
    const configuration = {
        url: `${getBaseUrl(deviceGuid, false)}details`,
        params: {}
    }
    return useSWR<ThermostatDetails, Error>(configuration, RestDataLoader.fetchData);
}